import * as Yup from 'yup';

const today = new Date();
today.setHours(0, 0, 0, 0);

export default Yup.object().shape({
  dismissed_at: Yup.date().required('Pflichtfeld').min(today, 'Datum liegt in der Vergangenheit').nullable(),
  dismissal_reason: Yup.string().max(255, 'max. 255 Zeichen').nullable(),
});
